// extracted by mini-css-extract-plugin
module.exports = {"panel":"App_panel__2es-6","panel2":"App_panel2__3ZNfB"};